import { render, staticRenderFns } from "./airLine.vue?vue&type=template&id=a60d02d8&scoped=true&"
import script from "./airLine.vue?vue&type=script&lang=js&"
export * from "./airLine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60d02d8",
  null
  
)

export default component.exports